/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/PanelManager.Props" />
import { ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";

export interface IPanelManagerProps {
    onCancel: () => void;
    onSave: (connectionToSave: ExternalConnection) => Promise<ExternalConnection>;
    connection?: ExternalConnection;
    existingProviderRepos?: { [providerKey: string]: ExternalGitRepo[] };
    existingServiceConnections: ExternalConnection[];
    panel: Panel;
    isGitHubApp: boolean;
    isAcquisitionFlow?: boolean;
}
